import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { painPoints } from "../../data/framework";
export function PainPointsSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:py-24" data-id="element-301" data-mp="1ble74g176ew8">
      <div className="mx-auto max-w-6xl" data-id="element-302" data-mp="1bo8q034kbrnj">
        <SectionHeading eyebrow="Does Any of This Sound Familiar?" title="If You Recognize Yourself in Even One of These Situations, This Resource Was Designed With Your Learning Needs in Mind." data-id="element-303" data-mp="1gl8y0jkz34ha" />

        <ol className="mx-auto mt-10 grid max-w-5xl gap-x-10 gap-y-2 md:grid-cols-2" data-id="element-304" data-mp="nwtscnnqdyim">
          {painPoints.map((point, i) => <li key={point.title} className="flex gap-4 border-b border-navy-900/10 py-5" data-id="element-305" data-mp="sxr9qy0x2oj2" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand text-sm font-black text-white" data-id="element-306" data-mp="xs4y4gh5vve8">
                {i + 1}
              </span>
              <div data-id="element-307" data-mp="297tlva28oyg3">
                <h3 className="text-[17px] font-extrabold leading-snug text-ink" data-id="element-308" data-mp="29bhg6bfidovv">{point.title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-ink-muted" data-id="element-309" data-mp="2r0outiuurs7h">{point.text}</p>
              </div>
            </li>)}
        </ol>

        <SectionCta label="Yes, This Is Me — I Want the Blueprint" data-id="element-310" data-mp="2i11r2qeniab9" />
      </div>
    </section>;
}